export const PHONE_NUMBER_ERROR_MAP = [
  'Invalid phone number format',
  'Invalid country code',
  'Phone number too short',
  'Phone number too long',
  'Invalid phone number format',
];
